<template>
  <div class="hero-shell hero-wrapper">
    <div v-if="!heroSwiperReady" class="hero">
      <NuxtLink class="hero-slide-link" :to="localePath('/category/voda')">
        <picture>
          <source srcset="/images/hero/hero-xl.avif" media="(min-width: 768px)">
          <img
            src="/images/hero/hero-sm.avif"
             :alt="$t('index.heroAlt')"
             class="hero-static"
            width="402"
            height="329"
            fetchpriority="high"
          >
        </picture>
        <span class="btn-cta first-slide">{{ $t('index.browseShop') }}</span>
      </NuxtLink>
    </div>
    <ClientOnly>
      <swiper-container
        v-if="heroSwiperReady"
        ref="heroRef"
        :init="false"
        class="hero"
      >
        <swiper-slide>
          <NuxtLink
            class="hero-slide-link"
            :to="localePath('/category/voda')"
            @click.capture="onHeroSlideClick"
          >
            <picture>
              <source srcset="/images/hero/hero-xl.avif" media="(min-width: 768px)">
              <img
                src="/images/hero/hero-sm.avif"
                :alt="$t('index.heroAlt')"
                class="w-full h-auto"
                width="402"
                height="329"
                fetchpriority="high"
              >
            </picture>
            <span class="btn-cta first-slide">{{ $t('index.browseShop') }}</span>
          </NuxtLink>
        </swiper-slide>
        <swiper-slide>
          <NuxtLink
            class="hero-slide-link"
            :to="localePath('/category/kafe')"
            @click.capture="onHeroSlideClick"
          >
            <picture>
              <source srcset="/images/hero/02-banner-coffee.avif" media="(min-width: 768px)">
              <img
                src="/images/hero/02-banner-coffee-mobile.avif"
                :alt="$t('index.heroCoffeeAlt')"
                class="w-full h-auto"
                width="804"
                height="658"
                loading="lazy"
              >
            </picture>
            <span class="btn-cta first-slide">{{ $t('index.browseShop') }}</span>
          </NuxtLink>
        </swiper-slide>
      </swiper-container>
    </ClientOnly>
  </div>
  <section class="content background-waves">
    <perks :perks="getPerks"/>
    <h1 class="mt-6">{{ $t('index.heroH1') }}</h1>
    <p class="display-2 mt-1">{{ $t('index.heroSubline1') }}<br>{{ $t('index.heroSubline2') }}</p>
    <section class="content banner-and-perks">
      <div class="banner">
        <video
          ref="waterVideoRef"
          muted
          loop
          playsinline
          preload="none"
          poster="/videos/poster-optimized_water.avif"
          width="640"
          height="360"
          aria-hidden="true"
        />
        <h2 class="display-1">{{ $t('index.selectedProducts') }}</h2>
        <p class="display-2">{{ $t('index.qualityGuarantee') }}</p>
      </div>
      <ul class="list-of-perks">
        <li>
          <img src="/icons/categories/water-drop.svg" alt="">
          <div>
            <h3 class="display-2"><span class="accent">{{ $t('index.perkWatersAccent') }}</span> {{ $t('index.perkWatersRest') }}
            </h3>

            <p>{{ $t('index.perkWatersBody') }}</p>

          </div>
        </li>
        <li>
          <img src="/icons/categories/dispenser.svg" alt="">
          <div>
            <h3 class="display-2">{{ $t('index.perkDispensersBefore') }} <span class="accent">{{ $t('index.perkDispensersAccent') }}</span> {{ $t('index.perkDispensersAfter') }}
            </h3>

            <p>{{ $t('index.perkDispensersBody') }}</p>

          </div>
        </li>
        <li>
          <img src="/icons/categories/bio.svg" alt="">
          <div>
            <h3 class="display-2">{{ $t('index.perkBioBefore') }} <span
                class="accent">{{ $t('index.perkBioAccent') }}</span>
            </h3>

            <p>{{ $t('index.perkBioBody') }}</p>

          </div>
        </li>
        <li>
          <img src="/icons/leaves.svg" alt="">
          <div>
            <h3 class="display-2">{{ $t('index.perkCompostBefore') }} <span class="accent">{{ $t('index.perkCompostAccent') }}</span>
            </h3>

            <p>{{ $t('index.perkCompostBody') }}</p>

          </div>
        </li>
      </ul>
    </section>
  </section>
  <banner-brands></banner-brands>
  <div class="banner content-padding content">
    <video
      ref="orderVideoRef"
      muted
      loop
      playsinline
      preload="none"
      poster="/videos/poster-optimized_order.avif"
      width="640"
      height="360"
      aria-hidden="true"
    />
    <p class="display-3">{{ $t('index.universePrefix') }}</p>
    <h2 class="display-1">{{ $t('index.universeTitle') }}</h2>
    <p class="display-3">{{ $t('index.universeSuffix') }}</p>
  </div>
  <section id="about-us" class="mt-4">
    <ul>
      <li>
        <h3 class="display-1"><span class="accent">{{ $t('index.aboutServiceAccent') }}</span> {{ $t('index.aboutServiceRest') }}</h3>

        <picture>
          <source srcset="/images/index/1-xl.avif" media="(min-width: 640px)">
          <NuxtImg src="/images/index/1.avif" alt="Illustration" class="w-full h-auto" width="152" height="237" loading="lazy"/>
        </picture>

        <p>{{ $t('index.aboutServiceBody') }}</p>
      </li>

      <li>
        <h3 class="display-1"><span class="accent">{{ $t('index.aboutDeliveryAccent') }}</span> {{ $t('index.aboutDeliveryRest') }}</h3>

        <picture>
          <source srcset="/images/index/2-xl.avif" media="(min-width: 640px)">
          <NuxtImg src="/images/index/2.avif" alt="Illustration" class="w-full h-auto" width="189" height="112" loading="lazy"/>
        </picture>

        <p>{{ $t('index.aboutDeliveryBody1') }}<br><br>
          {{ $t('index.aboutDeliveryBody2') }}</p>
      </li>

      <li>
        <h3 class="display-1"><span class="accent">{{ $t('index.aboutDiscountsAccent') }}</span> {{ $t('index.aboutDiscountsRest') }}</h3>

        <picture>
          <source srcset="/images/index/3-xl.avif" media="(min-width: 640px)">
          <NuxtImg src="/images/index/3.avif" alt="Illustration" class="w-full h-auto" width="126" height="141" loading="lazy"/>
        </picture>

        <p>{{ $t('index.aboutDiscountsBody') }}</p>
      </li>
    </ul>
  </section>
  <section id="our-brand" class="content">
    <h2 class="display-1">{{ $t('index.ownBrandBefore') }} <span class="accent">{{ $t('index.ownBrandAccent') }}</span> {{ $t('index.ownBrandAfter') }}</h2>
    <p class="display-3">{{ $t('index.ownBrandSubline') }}</p>
    <NuxtLink
      id="private-banner"
      class="mt-2"
      :to="localePath('/category/voda/7841-voda-private-water-immune-zn-k-mg-0-5l')"
    >
      <picture>
        <source
          srcset="/images/hero/01-banner-private-water.avif"
          media="(min-width: 640px)"
        >
        <NuxtImg
          src="/images/hero/01-banner-private-water-mobile.avif"
          alt="Private Water Immune"
          class="private-banner-img"
          width="3424"
          height="1132"
          loading="lazy"
        />
      </picture>
      <span class="btn-cta">{{ $t('index.orderCta') }}</span>
    </NuxtLink>
  </section>
  <section id="nature" class="content content-padding">
    <div class="nature-text">
      <h2 class="display-1">{{ $t('index.natureBefore') }} <span class="accent">{{ $t('index.natureAccent') }}</span>{{ $t('index.natureAfter') }}</h2>
      <p class="dark-blue">
        {{ $t('index.natureBody1') }}<br>
        {{ $t('index.natureBody2') }}<br>
        {{ $t('index.natureBody3') }}
      </p>
      <div class="mt-1">
        <NuxtLink class="btn-cta" :to="localePath('/nature')">{{ $t('index.natureCta') }}</NuxtLink>
      </div>
    </div>
    <NuxtLink :to="localePath('/nature')">
      <picture>
        <source srcset="/images/nature-banner-xl.avif" media="(min-width: 640px)">

        <NuxtImg src="/images/nature-banner.avif" alt="Illustration" class="w-full h-auto" width="343" height="343" loading="lazy"/>
      </picture>
    </NuxtLink>
  </section>
</template>


<script setup lang="ts">

useDefaultPageSeo('index')

const {t} = useI18n();
const localePath = useLocalePath();
const route = useRoute();
const router = useRouter();
const api = useApi();
const { showInfo, showError } = useAppToast();

useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/images/hero/hero-sm.avif',
      type: 'image/avif',
      media: '(max-width: 767px)',
      fetchpriority: 'high',
    },
    {
      rel: 'preload',
      as: 'image',
      href: '/images/hero/hero-xl.avif',
      type: 'image/avif',
      media: '(min-width: 768px)',
      fetchpriority: 'high',
    },
  ],
})

const getPerks = computed(() => {
  const perks = [];

  for (let i = 1; i <= 4; i++) {
    perks.push({
      title: t(`index.perk_${i}_title`),
      description: t(`index.perk_${i}_description`)
    });
  }
  return perks;
});
const waterVideoRef = useLazyVideo('/videos/optimized_water.mp4')
const orderVideoRef = useLazyVideo('/videos/optimized_order.mp4')
const heroSwiperReady = ref(false)
const heroRef = ref(null)
const heroSwiperOptions = {
  loop: true,
  grabCursor: true,
  simulateTouch: true,
  allowTouchMove: true,
  preventClicks: true,
  preventClicksPropagation: true,
  threshold: 10,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  speed: 700,
}
const swiper = useSwiper(heroRef, heroSwiperOptions)

function onHeroSlideClick(event: MouseEvent) {
  if (swiper.instance.value?.allowClick === false) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}

watch(heroRef, async (el) => {
  if (!el) return
  await nextTick()
  Object.assign(el, heroSwiperOptions)
  el.initialize()
  swiper.instance.value = el.swiper
  el.swiper?.autoplay?.start()
})

onMounted(async () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      heroSwiperReady.value = true
    })
  })

  const token = route.query.token as string | undefined;
  if (token) {
    try {
      await api('/Public/ClientUser/register-confirm', {
        method: 'GET',
        query: { token },
      });
      showInfo(t('registerConfirm.successMessage'), t('registerConfirm.successTitle'));
    } catch {
      showError(t('registerConfirm.errorMessage'));
    } finally {
      await router.replace({ query: { ...route.query, token: undefined } });
    }
  }
})
</script>


<style scoped>
/* The static image and the hydrated swiper occupy the same box; the swiper
   covers the image once it mounts, so neither the LCP paint nor the hydration
   causes a reflow. */
.hero-wrapper {
  position: relative;
  aspect-ratio: 402 / 329;

  @media (min-width: 768px) {
    aspect-ratio: 1728 / 870;
  }
}

.hero-wrapper :deep(.hero) {
  position: absolute;
  inset: 0;
}

.hero-wrapper :deep(swiper-slide) {
  height: 100%;
}

.hero-static {
  width: 100%;
  height: auto;
  display: block;
}

.hero-shell {
  width: 100%;
  aspect-ratio: 402 / 329;
  overflow: hidden;

  @media (min-width: 768px) {
    aspect-ratio: 1728 / 870;
  }
}

.hero {
  position: relative;
  width: 100%;
  height: 100%;

  .hero-slide-link {
    display: block;
    height: 100%;
    color: inherit;
    text-decoration: none;
  }

  img {
    width: 100%;
    height: auto;
    aspect-ratio: 402 / 329;
    object-fit: cover;

    @media (min-width: 768px) {
      aspect-ratio: 1728 / 870;
    }
  }

  .btn-cta {
    position: absolute;
    top: calc(270 / 329 * 100%);
    right: 40px;
    margin-left: 2.1rem;

    @media (min-width: 640px) {
      top: calc(290 / 329 * 100%);
      left: 100px;
      right: auto;
      text-align: left;
    }
  }
}
</style>
